// eslint-disable-next-line import/prefer-default-export
export const leaksDataSources = {
  pastebin: 'pastebin',
  github: 'github',
  gist: 'gist',
  websites: 'websites',
};
